var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/eye_on"
  }, /*#__PURE__*/React.createElement("g", {
    className: "iconz"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.659 12.005A3.664 3.664 0 0 1 12 15.682a3.664 3.664 0 0 1-3.659-3.677A3.664 3.664 0 0 1 12 8.328a3.664 3.664 0 0 1 3.659 3.677Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 20.5c3.608 0 6.97-2.137 9.31-5.834.92-1.449.92-3.883 0-5.332C18.97 5.637 15.608 3.5 12 3.5c-3.608 0-6.97 2.137-9.31 5.834-.92 1.449-.92 3.883 0 5.332C5.03 18.363 8.392 20.5 12 20.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye_on.dce6994dc052fc261300a43d08b2f1c6.svg";
export { ForwardRef as ReactComponent };